// Mock data for Agreenerside Ecotourism Farm

export const experiences = [
  {
    id: 1,
    title: "Plant Nursery",
    description: "Explore our diverse selection of sustainably produced plants. Learn about native species, organic growing practices, and select unique plants perfect for your lifestyle.",
    image: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/tlbi6wia_FB_IMG_1744396001300.jpg",
    icon: "Leaf"
  },
  {
    id: 2,
    title: "Greenhouses",
    description: "Step into our climate-controlled greenhouses where innovation meets tradition. Discover year-round growing techniques and sustainable horticulture practices.",
    image: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/5s1yqiee_FB_IMG_1744596937359.jpg",
    icon: "Sprout"
  },
  {
    id: 3,
    title: "U-Pick Vegetable Plots",
    description: "Harvest your own fresh, organic vegetables directly from our fields. Experience the joy of farm-to-table living and taste the difference of truly fresh produce.",
    image: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/5a60y4dq_1000004215.jpg",
    icon: "Apple"
  },
  {
    id: 4,
    title: "Permaculture Garden Design",
    description: "Wander through our beautifully designed permaculture gardens. Each space tells a story of biodiversity, ecological balance, and natural beauty.",
    image: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/xbriilmd_PXL_20250727_195622324.jpg",
    icon: "Flower2"
  },
  {
    id: 5,
    title: "Study Center",
    description: "Deepen your understanding of permaculture principles in our educational study center. Access resources, attend workshops, and connect with sustainability experts.",
    image: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/dczn35zp_PXL_20240203_202751654.MP.jpg",
    icon: "BookOpen"
  }
];

export const greenhouseGalleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/5s1yqiee_FB_IMG_1744596937359.jpg",
    alt: "Greenhouse interior with seedlings and sustainable growing practices"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/b2p361yp_PXL_20240424_220241587.jpg",
    alt: "Climate-smart cultivation - witness innovation in action as we extend growing seasons and protect tender plants through all weather"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/kpt53cut_PXL_20240420_204939457.jpg",
    alt: "Protected cultivation - greenhouse technology ensures optimal growing conditions for specialty crops and tender varieties"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/5xbbifl9_PXL_20240418_135347493.jpg",
    alt: "Greenhouse abundance - rows of thriving plants demonstrate the power of controlled environment agriculture"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/0ewoks1q_PXL_20240402_123154476.jpg",
    alt: "Horticultural studies in action - greenhouse production with organized rows of seedlings ready for transplanting"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/dt2zii3v_PXL_20240426_224450797.jpg",
    alt: "Mature tomato plants ready for transplant - greenhouse-grown for the strongest starts and earliest harvests"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/3npfqndz_PXL_20240412_130658663.jpg",
    alt: "Spring abundance - squash, tomatoes, and cucumbers fill the greenhouse floor, ready for garden planting season"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/g8op0354_PXL_20250222_122120674~2.jpg",
    alt: "Sustainability starts in the germination chamber - where we rear thousands of seedlings in the most efficient way during the harshest winter months"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/8htiwe33_PXL_20240412_130709734.jpg",
    alt: "Browse our diverse selection of spring garden transplants available April and May"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/xxx30aju_8501b860-1250-4062-a13d-1066dbad5da4-1_all_105.jpg",
    alt: "Greenhouse horticulture exploration - we embrace ancient agricultural techniques while exploring the future of biotech with innovations like the glowing petunia and purple tomato"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/d22q9329_1000004285.png",
    alt: "Family working together in the greenhouse - propagating the next generation of plants surrounded by trays of seedlings"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/rj76hmlo_1000004286.png",
    alt: "Hands-on propagation - transplanting cotton seedlings from plug trays to pots, nurturing the next generation"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/8oc4nvc1_1000004301.png",
    alt: "Exploring the tropical greenhouse - discovering exotic plants and learning about warm-climate growing"
  }
];

export const nurseryGalleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/la231br0_FB_IMG_1744396037312.jpg",
    alt: "Get lost and find yourself in the nursery with our diverse selection of native plants to choose from"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/91thh4m2_PXL_20250520_230047670.MP.jpg",
    alt: "Rare honey berries available growing in sustainable nursery containers"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/i418m836_PXL_20240417_134928320.jpg",
    alt: "Rows of possibilities - discover perennials, shrubs, and trees carefully propagated for your landscape dreams"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/yld7xz3k_PXL_20240417_135037991.jpg",
    alt: "From seedling to specimen - witness the journey of plant cultivation in our sustainably managed nursery beds"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/bv4iiemz_PXL_20240417_135752160.jpg",
    alt: "Nursery cultivation in progress - healthy plants receiving expert care before finding their forever homes"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/w94a1ksf_PXL_20240528_114424044.jpg",
    alt: "Diverse nursery beds under protective shade - where tender seedlings and rare varieties thrive together"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/so4kog2m_PXL_20240523_143524847.jpg",
    alt: "Young magnolias and fruit trees in grow bags - sustainably propagated and ready for your landscape"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/hmb84zs0_PXL_20240524_115318175.jpg",
    alt: "Rows of thriving nursery stock - AGreenerSide's collection of trees, shrubs, and perennials awaiting new homes"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/we81fsdc_PXL_20240603_205224597.jpg",
    alt: "Aerial view of the nursery - organized rows of diverse plants from fruit trees to ornamental shrubs"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/ddxr8w6z_PXL_20240528_115856740.jpg",
    alt: "Native grasses and perennials in the nursery - sustainable ground covers and landscape essentials"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/t6cxeod0_1000004290.png",
    alt: "Lush nursery beds overflowing with hostas, shrubs, and perennials - a tapestry of textures and shades of green"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/ixnqh8ry_1000004300.png",
    alt: "Variegated plants and water lilies creating a serene water garden display"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/7xgta1rs_0630220951.jpg",
    alt: "Nursery pathways beckon - explore our organized collection where every plant waits to find its perfect home"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/zdlci43x_1000004294.png",
    alt: "Tropical oasis - banana plants frame a water lily pond surrounded by lush perennials"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/dfk6olvm_1000004293.png",
    alt: "Black-eyed Susans and cannas create a stunning display of summer color"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/wrfwp304_1000004292.png",
    alt: "Water lily pond close-up - delicate blooms floating among lily pads in the morning light"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/cz7c3ma7_1000004306.png",
    alt: "Calla lilies and cannas in the nursery beds - elegant blooms ready for your garden"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/w6jh6o69_1000004304.png",
    alt: "Nursery overview with hoop house - rows of plants being nurtured for the next growing season"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/gwnj66d2_1000004302.png",
    alt: "Lotus plants emerging from the pond - sacred blooms rising above the water"
  }
];

export const gardenBeautyImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/m8ov4sv0_PXL_20240502_101917000.jpg",
    alt: "Portal to abundance - where garden pathways lead through layers of life, inviting you into nature's intimate classroom of perpetual growth and discovery"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/i2t6b6p2_PXL_20240529_211240088.jpg",
    alt: "Sanctuary within sanctuary - where thoughtful design creates spaces for both human reflection and wild creatures, honoring the interconnected web of life"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/lm19779v_FB_IMG_1769619149527.jpg",
    alt: "Living tapestry of biodiversity - each plant plays its role in this self-sustaining ecosystem, from pollinators to soil builders"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/q9xjqt4w_FB_IMG_1769619161341.jpg",
    alt: "Nature's layered cathedral - witness how permaculture creates vertical food forests where trees, shrubs, and groundcovers thrive together in perfect harmony"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/r8bkstec_FB_IMG_1769619116596.jpg",
    alt: "Where wildflowers meet intention - permaculture gardens dance between cultivated abundance and nature's spontaneous beauty"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/wijhbvvh_KIMG0610.jpg",
    alt: "Ancient wisdom meets modern practice - exploring ethnobotanical traditions where every plant tells a story of human connection across cultures and centuries"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/dw0nsw3x_KIMG0701.jpg",
    alt: "The art of living soil - where anthropology and agriculture converge, revealing how humanity has always been shaped by the plants we tend"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/8k6qdqna_FB_IMG_1499604787709.jpg",
    alt: "Nature's gallery - witness botanical artistry in motion, each leaf and bloom a masterpiece painted by sun, soil, and seasons"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/pij5fwrg_received_10209448404543927.jpeg",
    alt: "Living heritage - where ornamental beauty preserves ancestral plant wisdom, bridging cultures through botanical artistry and timeless cultivation traditions"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/0mo6tpl4_0612220608a.jpg",
    alt: "Garden pathways illuminated - where morning light reveals the sacred architecture of permaculture design, inviting contemplation and connection"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/iwdg3blx_PXL_20240605_114856379.jpg",
    alt: "Pollinator paradise - zinnias, sunflowers and cosmos create a vibrant tapestry of color attracting bees and butterflies throughout the season"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/k0fzicj4_PXL_20240527_125710583.jpg",
    alt: "Pond sanctuary - where water lilies bloom and native grasses create habitat for wildlife, demonstrating the beauty of aquatic permaculture"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/yc1519cp_PXL_20240520_124435367.jpg",
    alt: "The old conservatory before we had to dismantle it - all these ferns were naturally occurring"
  },
  {
    id: 150,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/wwa01wtr_1000004305.png",
    alt: "Before the ferns grew up. It was a succulent house."
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/fclnx6mm_PXL_20251005_191736407.MP.jpg",
    alt: "Native pollinator boneset in bloom - part of our seed saving initiative, preserving heritage plants for future generations"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/0vf9dt6u_1000000451.jpg",
    alt: "One of our installs Quantico, Maryland - where this front yard was once plain turf, now transformed into a thriving food forest"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/vverz3nq_1000000452.jpg",
    alt: "Quantico, Maryland permaculture transformation - from turf to abundance, showcasing the beauty and productivity of regenerative landscape design"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/j3c2s1d5_1000004296.png",
    alt: "Sunflowers standing tall in the summer garden - cheerful blooms attracting pollinators and bringing joy to visitors"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/lhynhxpa_1000004295.png",
    alt: "Tropical paradise corner - hardy bananas create a lush backdrop for relaxing under the red umbrella"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/uyccu9a5_1000004291.png",
    alt: "Summer abundance - vegetable garden in full production with squash, tomatoes, sunflowers, and millet"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/a1dkzuo2_1000004303.png",
    alt: "Japanese maples and ornamental plants create layers of texture and color in the garden"
  }
];

export const upickHarvestImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/x55jg7e9_PXL_20250624_131707928.jpg",
    alt: "U-Pick gardens in full summer glory - explore our diverse selection of vegetables, herbs, and flowers ready for harvest"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/6upldcan_PXL_20250919_180857642.MP.jpg",
    alt: "Delicious pears ripening on the tree - available for u-pick in the fall, a sweet seasonal treat from our orchard"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/15ffyari_FB_IMG_1769619102687.jpg",
    alt: "Vibrant pepper harvesting season - experience the full spectrum of colors and flavors in our u-pick pepper patch"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/drrt504w_PXL_20250603_155845636.MP.jpg",
    alt: "Fresh fruit picking under the goumi berry patch u-pick experience"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/7nfo1vu1_PXL_20250911_163332715.MP.jpg",
    alt: "Jujube - a delicious unique fruit called Chinese date u-pick"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/lppcenmi_PXL_20250908_141956919.MP.jpg",
    alt: "Raw watermelon juice - part of our studies on hydration for your cells, feeding the fascia"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/d0xxdl78_PXL_20251101_185323537.MP.jpg",
    alt: "Harvesting hibiscus Roselle for tea in the u-pick field - learn to grow and prepare vitamin-rich herbal teas"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/lugcybv5_1000001296.jpg",
    alt: "Dried hibiscus for tea - learn to transform your u-pick harvest into delicious artisanal products"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/x92rin8j_FB_IMG_1769619184524.jpg",
    alt: "Gourmet peppers ready for harvest, farm-to-table experience"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/584xk9ex_FB_IMG_1769619140227.jpg",
    alt: "Garden-fresh herbal harvests - learn to identify and use healing plants"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/i164fmr9_FB_IMG_1769679345193.jpg",
    alt: "Abundant summer harvest garden - a lush tapestry of edibles including holy basil, sweet potato, and tropical turmeric"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/jtw3acdj_8501b860-1250-4062-a13d-1066dbad5da4-1_all_1044.jpg",
    alt: "Fresh peanut harvest - discover the magic of growing your own legumes from seed to table in our u-pick plots"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/1saskzns_8501b860-1250-4062-a13d-1066dbad5da4-1_all_1241.jpg",
    alt: "Fig trees laden with fruit - our orchard offers multiple varieties of figs ripening throughout the season"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/q93sro72_1000002711.jpg",
    alt: "Fresh figs fresh picked - discover the sweetness of sun-ripened figs straight from our orchard"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/0ahfw1ni_1000002601.jpg",
    alt: "Bountiful fig harvest - boxes of fresh picked figs showcasing the abundance of our u-pick orchards"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/5fanawqb_PXL_20251101_210901832.MP.jpg",
    alt: "Hydroponic lettuce - exploring technology and innovation alongside organic growing methods"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/jyr5wym4_1000002762.jpg",
    alt: "Fresh harvest bounty - a paper bag overflowing with pears, squash, figs, and seasonal vegetables from our u-pick gardens"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/y3agz479_1000002189.jpg",
    alt: "Garlic harvest day - wheelbarrow loaded with freshly dug garlic bulbs, cured and ready for the kitchen"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/io5r52gk_1000001957.jpg",
    alt: "Honeyberry harvest with dried peppers - the diverse flavors of our u-pick experience"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/j1eg854w_1000004264.jpg",
    alt: "Banana pepper plants in the field - rows of productive pepper plants ready for u-pick harvesting"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/dc9chtve_1000004297.png",
    alt: "Fresh elderberries harvested from the farm - perfect for making immune-boosting syrup and wine"
  },
  {
    id: 22,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/8mh5wy0m_1000004308.jpg",
    alt: "AGreenerSide at the farmers market - sharing our harvest and passion with the community"
  },
  {
    id: 23,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/zpb0ifdt_1000004309.jpg",
    alt: "Fresh pawpaw harvest - America's largest native fruit with tropical custard flavor"
  }
];

export const farmMomentsImages = [
  {
    id: 0,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/pyitnr5u_1000003475.jpg",
    alt: "Evening bonfire on the farm - where community gathers and stories are shared under the stars"
  },
  {
    id: 100,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/74p88zuv_1000004289.png",
    alt: "Making biochar for the nursery and plants"
  },
  {
    id: 101,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/w6voykw0_1000004311.png",
    alt: "Outdoor gathering under the tent with fire pit smoke rising - farm life at its coziest"
  },
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/y7g4gio6_PXL_20250529_174404515.jpg",
    alt: "Lush permaculture garden with wildflowers and natural biodiversity"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/7bixge20_PXL_20251114_114738699.MP.jpg",
    alt: "First frost - understanding our climate and learning how to tend your garden through the seasons, embracing nature's rhythms"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/82tk857u_PXL_20251004_185703259.MP.jpg",
    alt: "From seed to harvest - witness the journey of regenerative farming practices"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/8ozedm0m_PXL_20250509_204450134.jpg",
    alt: "Community roots run deep - join us in cultivating connections through sustainable agriculture"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/5upljzwj_PXL_20250529_141437650.jpg",
    alt: "Welcome to AGreenerSide - where nature greets you the moment you arrive, inviting you into our green sanctuary"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/8eec2bd9_PXL_20250526_155652668.jpg",
    alt: "Join the movement - be part of our growing community building a sustainable future together, one plant at a time"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/f78bpbsk_PXL_20240415_214956682.jpg",
    alt: "Evening tranquility - where farm life slows down and nature's nocturnal rhythms begin their ancient dance"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_plant-sanctuary-2/artifacts/sinrilza_PXL_20240415_215005011.jpg",
    alt: "Twilight sanctuary - the farm transformed by golden hour, reminding us that beauty exists in every moment of the growing season"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/s921v62v_PXL_20240524_223833866.jpg",
    alt: "Wildlife encounters - a friendly broadhead skink explores the garden, one of many beneficial creatures that call our farm home"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/i4sn62kt_PXL_20240514_183423624.jpg",
    alt: "Hands in the soil - our team preparing young trees and shrubs for their new homes, nurturing the next generation of the food forest"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_sustainable-farm-5/artifacts/x125qymf_PXL_20251003_154159464.MP.jpg",
    alt: "The turtles have returned! After completing restoration and expansion on the pond, wildlife is thriving once again in our aquatic ecosystem"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/ypqhr6v2_8501b860-1250-4062-a13d-1066dbad5da4-1_all_1355.jpg",
    alt: "Fireside gatherings - cooking over open flames connects us to ancient traditions and the primal joy of farm-fresh meals"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/bh1figiy_8501b860-1250-4062-a13d-1066dbad5da4-1_all_851.jpg",
    alt: "Farmers market - bringing our sustainably grown produce and plants directly to the community"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/n1i442ba_1000000536.jpg",
    alt: "Winter ice sculptures in full effect - nature's frozen artistry transforms the farm into a crystalline wonderland"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/jaybdte9_1000001236.jpg",
    alt: "Winter ice sculptures in full effect - delicate ice formations adorn the garden landscape"
  },
  {
    id: 16,
    url: "https://customer-assets.emergentagent.com/job_greenerside/artifacts/c93pzi24_8501b860-1250-4062-a13d-1066dbad5da4-1_all_860.png",
    alt: "One of our off-the-farm expo exhibits - sharing our passion for sustainable horticulture with the wider community"
  },
  {
    id: 17,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/cudpnrto_1000004283.png",
    alt: "During your visit, enjoy the ancient trees across the st. at Old Trinity Church on the water"
  },
  {
    id: 18,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/athqwgdx_1000004299.png",
    alt: "Heritage turkeys and chickens roaming the farm - our feathered friends help with pest control and add life to the landscape"
  },
  {
    id: 19,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/49junt72_1000004315.png",
    alt: "Farm tour in progress - visitors exploring the grounds with the hoop house in the background"
  },
  {
    id: 20,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/zgsd1n7e_1000004313.png",
    alt: "Turkeys and chickens finding shade under the fig tree - farm animals living their best life"
  },
  {
    id: 21,
    url: "https://customer-assets.emergentagent.com/job_8dd72256-8be3-463b-b99e-d76e047a07af/artifacts/2zx2j3qb_1000004312.png",
    alt: "Farm crafts station - natural dyeing and candle making with homegrown materials"
  }
];

export const galleryImages = [...upickHarvestImages, ...greenhouseGalleryImages, ...nurseryGalleryImages, ...gardenBeautyImages, ...farmMomentsImages];

export const timeSlots = [
  "9:00 AM", "10:00 AM", "11:00 AM", 
  "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM"
];

export const visitTypes = [
  { id: "nursery-shop", label: "Nursery Shop - No need to book! Just come by.", duration: "" },
  { id: "guided-tour", label: "Guided Tour", duration: "1 hour" },
  { id: "workshop", label: "Permaculture Workshop", duration: "4 hours" },
  { id: "day-pass", label: "Full Day Experience", duration: "8 hours" },
  { id: "private-session", label: "Private Study Session", duration: "3 hours" }
];

// Mock booking submission
export const submitBooking = async (bookingData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Store in localStorage for demo
  const bookings = JSON.parse(localStorage.getItem('agreenerside_bookings') || '[]');
  const newBooking = {
    ...bookingData,
    id: Date.now().toString(),
    status: 'confirmed',
    createdAt: new Date().toISOString()
  };
  bookings.push(newBooking);
  localStorage.setItem('agreenerside_bookings', JSON.stringify(bookings));
  
  return newBooking;
};

// Get user bookings
export const getUserBookings = () => {
  return JSON.parse(localStorage.getItem('agreenerside_bookings') || '[]');
};
